module.exports = __webpack_public_path__ + "img/fabrix-api-portal.5bafaf55.jpg";